export const firebaseConfig = {
  apiKey: 'AIzaSyCmE7VRStASx6kQbtS7sYVsrskEptWxQDc',
  authDomain: 'manteltop-rn.firebaseapp.com',
  projectId: 'manteltop-rn',
  storageBucket: 'manteltop-rn.appspot.com',
  messagingSenderId: '323153414423',
  appId: '1:323153414423:web:190677ad65b06f41158f52',
  measurementId: 'G-SCTKQCN1HK',
};
